import React from 'react';
import * as S from './styles';
import PlaceholderRow, {
  PlaceholderVariant,
} from '../item-row/placeholder-row';

type Props = {
  icon: string;
  variant: PlaceholderVariant;
  isAlert?: boolean;
};

const PlaceholderList = ({ icon, variant, isAlert }: Props) => {
  return (
    <S.PlaceholderListItem
      draggable={false}
      styling={isAlert ? 'lines' : 'background'}
      deleting={false}
    >
      <S.Content>
        <PlaceholderRow icon={icon} variant={variant} isAlert={isAlert} />
      </S.Content>
    </S.PlaceholderListItem>
  );
};

export default PlaceholderList;
